import { ref } from 'vue'
import { CurrentUserAndPermissions, Organization } from '@/generated/graphql'
import { floor } from 'lodash'

export function itemSortByName<T>(items: T[] | undefined, extractor: (item: T) => string): T[] {
  if (!items) {
    return []
  }
  return JSON.parse(JSON.stringify(items)).sort((a: T, b: T) =>
    extractor(a).localeCompare(extractor(b)),
  )
}
export function itemSortByNumber<T>(items: T[] | undefined, extractor: (item: T) => number): T[] {
  if (!items) {
    return []
  }
  return JSON.parse(JSON.stringify(items)).sort((a: T, b: T) => extractor(a) - extractor(b))
}
export function sortTree<T>(
  items: T[] | undefined,
  hasChildrenExtractor: (item: T) => boolean,
  nameExtractor: (item: T) => string,
): T[] {
  if (!items) {
    return []
  }
  return JSON.parse(JSON.stringify(items)).sort((a: T, b: T) => {
    const aHasChildren = hasChildrenExtractor(a)
    const bHasChildren = hasChildrenExtractor(b)
    if (aHasChildren && !bHasChildren) {
      return -1
    }
    if (bHasChildren && !aHasChildren) {
      return 1
    }

    return nameExtractor(a).localeCompare(nameExtractor(b))
  })
}

export function uniqueArray<T, P>(array: T[], propertyExtractor: (item: T) => P) {
  return array.filter(
    (value, index, self) =>
      index === self.findIndex((t) => propertyExtractor(t) === propertyExtractor(value)),
  )
}

export const secondsToHumanReadable = (seconds?: number) => {
  if (!seconds) {
    return ''
  }

  let remainder = seconds
  let ret = ''
  const units = [
    { unit: 'd', count: 86400 },
    { unit: 'h', count: 3600 },
    { unit: 'm', count: 60 },
    { unit: 's', count: 1 },
  ]
  units.forEach(({ unit, count }) => {
    if (remainder < count) {
      return
    }

    const units = floor(remainder / count)
    remainder -= units * count
    ret += `${units}${unit}`
  })

  return ret
}

export const currentOrganization = ref<Organization>()
export const currentUserAndPermissions = ref<CurrentUserAndPermissions | undefined>()
